import classnames from 'classnames';

const valueToLowerCase = (value) =>
  typeof value === 'string' ? value.toLowerCase() : '';

const toSafeString = (value) => (typeof value === 'string' ? value : '');

function CustomPhoneField({ field = {}, value, onChange, onBlur, name, ref }) {
  const { size, autoComplete, labelFor, isRequired, placeholder } = field;

  const describedBy = `gfield_description_${labelFor?.replace('name_', '')}`;

  return (
    <input
      ref={ref}
      className={classnames(valueToLowerCase(size))}
      id={labelFor}
      name={name}
      aria-invalid={undefined}
      aria-required={isRequired}
      aria-describedby={describedBy}
      type="tel"
      placeholder={placeholder}
      autoComplete={autoComplete}
      value={toSafeString(value)}
      onChange={onChange}
      onBlur={onBlur}
    />
  );
}

CustomPhoneField.validation = ({ fieldData, strings }) => {
  const requiredMessage =
    fieldData?.errorMessage ||
    strings?.errors?.required ||
    'This field is required.';

  return {
    rules: {
      required: fieldData?.isRequired ? requiredMessage : false,
    },
    defaultValue: '',
  };
};

export default CustomPhoneField;
